import { useNavigate } from 'react-router-dom';
import LanguageSelector from './Entities/LanguageSelector';
import logo from './assets/logotypes/logo_white.png';
import './styles/Header.css';

function NoUserHeader() {
  const navigate = useNavigate();

  return (
    <header className="no-user-header-container">
      <div className="icon-group left">
        <span className="header-icon" title="Help" onClick={() => navigate('/help')}>
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
            <line x1="12" y1="17" x2="12" y2="17"/>
          </svg>
        </span>
      </div>
      <div className="logo-center">
        <img
          src={logo}
          className="logo-image clickable-logo"
          alt="Logo"
          onClick={() => navigate('/home')}
          style={{ cursor: 'pointer' }}
        />
      </div>
      <div className="icon-group right">
        <LanguageSelector />
      </div>
    </header>
  );
}

export default NoUserHeader;
